<template>
  <div class="content-summary-snippet">
    <div v-if="!hasPost" class="content-summary-snippet__title content-summary-snippet__title--yellow-text">
      <IconEmbedded name="warning_3" :size="16" color="rgba(177, 110, 3, 1)" style="margin-right: 5px" />
      No Content Source
    </div>

    <!-- Content summary empty -->
    <div class="content-summary-empty content-summary-snippet__content">
      <div class="content-summary-empty__drag-n-drop-area" :style="{ boxShadow: hasPost ? 'none' : '0 0 0 3px #e9ba55' }">
        <div style="margin: 0 20px 5px 20px; text-align: center; text-wrap: balance" :style="{ color: hasPost ? 'inherit' : 'rgba(177, 110, 3, 1)' }">
          {{ hasPost ? "User manually uploaded photos." : "Sorry, we didn't find content for this topic." }}
        </div>
        <!--<LinkWithIcon class="content-summary-empty__link-with-icon" isDottedUnderline color="yellow" @click="emit('clickUploadContent')">
          <template #icon>
            <IconEmbedded name="upload_2" :size="19" />
          </template>
          <span style="white-space: nowrap">Upload Content</span>
        </LinkWithIcon>

        <LinkWithIcon v-if="!hasPost" class="content-summary-empty__link-with-icon" isDottedUnderline color="yellow" @click="emit('clickPickFromExisting')">
          <template #icon>
            <IconEmbedded name="image_2" :size="19" />
          </template>
          <span style="white-space: nowrap">Manually pick an album</span>
        </LinkWithIcon>

        <LinkWithIcon class="content-summary-empty__link-with-icon" isDottedUnderline color="yellow">
          <template #icon>
            <IconEmbedded name="bulb_2" :size="19" />
          </template>
          <span style="white-space: nowrap">Suggest Alternative</span>
        </LinkWithIcon>-->
      </div>
    </div>
    <!-- / Content summary empty -->
  </div>
</template>

<script setup lang="ts">
// Components
import IconEmbedded from "@components/ui/IconEmbedded.vue";

defineProps<{
  hasPost?: boolean;
}>();
</script>

<style scoped lang="scss">
@import "./contentSummarySnippet.scss";
@import "@/scss/variables.scss";

// Content summary empty ======================================================
.content-summary-empty {
  @include standardFont;
  position: relative;
  z-index: 0;

  &--darkened {
    outline: 1px rgba(255, 0, 0, 0.25) solid !important;
    &::before {
      content: "";
      width: 100%;
      height: 100%;
      border-radius: 100px;
      position: absolute;
      inset: 0 auto auto 0;
      z-index: 2;
      background: rgba(230, 230, 230, 1);
    }
  }

  &__title {
    gap: 4px;
    margin-bottom: 9px;
    display: flex;
    align-items: center;
    color: rgba(177, 110, 3, 1);
    font-weight: bold;
  }

  &__drag-n-drop-area {
    gap: 6px;
    padding: 12px 0 16px;
    border: 1px #b7b7b7 dashed;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0 0 0 3px #e9ba55;
  }

  &__link-with-icon {
  }
}
</style>
